module.exports = __webpack_public_path__ + "img/07.3017c1ec.png";